import { createFeatureSelector } from '@ngrx/store';

import { InlineFilterState } from './inline-filter.models';

export const INLINE_FILTER_FEATURE = 'inlineFilter';

export const selectInlineFilterFeature = createFeatureSelector<InlineFilterState>(INLINE_FILTER_FEATURE);
